import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

const TableCell = ({ title, titleTooltip, description, description2, additional, icon }) => {
    return (
        <div className={cn(styles.cell, icon && styles["cell--with-icon"])}>
            <div className={styles.cell__content}>
                <div className={cn(styles.cell__title, titleTooltip && styles["cell__title--hasTooltip"])}>
                  {icon && icon}
                  <span className={styles.cell__titleText}>{title}</span>
                  {titleTooltip && <span className={styles.cell__tooltip}>{titleTooltip}</span>}
                </div>
                {description && <div className={styles.cell__description} title={description}>{description}</div>}
                {description2 && <div className={styles.cell__description} title={description2}>{description2}</div>}
                {additional && <div className={styles.cell__additional} title={additional}>{additional}</div>}
            </div>
        </div>
    );
};

export default TableCell;
